export const AccessLevels = [
  { text: 'Consultor', value: 'consultant' },
  { text: 'Supervisor', value: 'supervisor' },
  { text: 'Gerente', value: 'manager' },
  { text: 'Financeiro', value: 'financier' },
  { text: 'Administrador', value: 'admin' }
];
